'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Redirector = exports.Initializer = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise2 = require('babel-runtime/core-js/promise');

var _promise3 = _interopRequireDefault(_promise2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp, _class2, _temp2, _dec, _dec2, _class3, _class4, _temp3;

var _reactRouter = require('react-router');

var _components2 = require('components');

var _connectData = require('helpers/connectData');

var _connectData2 = _interopRequireDefault(_connectData);

var _reactRedux = require('react-redux');

var _docs = require('redux/modules/docs');

var _redux = require('redux');

var _reactBootstrap = require('react-bootstrap');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _info = require('redux/modules/info');

var _utils = require('../../../api/actions/Db/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Initializer: {
    displayName: 'Initializer'
  },
  Redirector: {
    displayName: 'Redirector'
  },
  Docs: {
    displayName: 'Docs'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/containers/Docs/Docs.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import { CounterButton, GithubButton } from 'components';
// import config from '../../config';


// import ga from 'react-google-analytics';
// import config from '../../config';
var initilized = { value: false };

var Initializer = exports.Initializer = _wrapComponent('Initializer')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(Initializer, _Component);

  function Initializer() {
    (0, _classCallCheck3.default)(this, Initializer);
    return (0, _possibleConstructorReturn3.default)(this, (Initializer.__proto__ || (0, _getPrototypeOf2.default)(Initializer)).apply(this, arguments));
  }

  (0, _createClass3.default)(Initializer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (initilized.value) return;
      var htmlCollection = window.document.getElementsByClassName('active treeItem');
      // htmlCollection nemá foreach:
      [].forEach.call(htmlCollection, function (el) {
        if (el.scrollIntoViewIfNeeded) {
          // mel by mit, ale pro jistotu
          el.scrollIntoViewIfNeeded();
          // console.log('aktivuji vybrané polozky..');
        }
      });
      // const supportedBrowser = 'Ami/Dmi'.split(/([A-H]\d?\d?[#|b]?(|mmaj||Maj|maj|m(i)?|moll|dim|sus|(m)?min|add|(A|a)ug)?(\d{0,2})(add|\(th\))?[^( |\)|\(|,|\/|a|c-z)]*)/)[1] === 'Ami';
      // if (!supportedBrowser) {
      //   alert('Váš prohlížeč není poporován. Nainstalujte prosím nějaký jiný prohlížeč, např.Google Chrome (nebo FireFox, Opera). Písně se nebudou zobrazovat správně.'
      //     + '\r\n\r\n Your browser is not supported, please install Google Chrome (or Firefox, or Opera). Song-view is not working correctly.');
      // }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react3.default.createElement('span', { className: 'Initializer' });
    }
  }]);
  return Initializer;
}(_react2.Component), _class.propTypes = {}, _temp));

var Redirector = exports.Redirector = _wrapComponent('Redirector')((_temp2 = _class2 = function (_Component2) {
  (0, _inherits3.default)(Redirector, _Component2);

  function Redirector() {
    (0, _classCallCheck3.default)(this, Redirector);
    return (0, _possibleConstructorReturn3.default)(this, (Redirector.__proto__ || (0, _getPrototypeOf2.default)(Redirector)).apply(this, arguments));
  }

  (0, _createClass3.default)(Redirector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.location.replace(this.props.url);
    }
  }, {
    key: 'render',
    value: function render() {
      var url = this.props.url;

      return _react3.default.createElement(
        'div',
        null,
        url
      );
    }
  }]);
  return Redirector;
}(_react2.Component), _class2.propTypes = {
  url: _react2.PropTypes.string.isRequired
}, _temp2));

function fetchData(getState, dispatch, location, routeParams) {
  var state = getState(); // TODO: zde je předchozí stav
  // const routerParams = state.router ? state.router.params : null;
  var promises = [];
  // zde se kontroluje, zda je již načtený stav
  if (routeParams) {
    if (routeParams.itemId === 'playlists') {
      //jen pokud nejsou nahrane:
      if (!state.docs.publicPlaylists) {
        //nahrajeme vsechny verejne playlisty
        promises.push(dispatch((0, _docs.loadPlaylists)()));
      }
      if (routeParams.subItemId) {
        var plId = routeParams.subItemId.substring(2);
        if (!state.docs.playLists.some(function (pl) {
          return pl.id === plId;
        })) promises.push(dispatch((0, _docs.loadPlaylistData)(plId)));
      }
    } else {

      // zda jsou nahrané písně pro daného interpreta nebo playlistu (!!)(=itemId)
      if (routeParams.itemId) {
        //pozor! metoda isSongsLoaded overi i zda jsou nahrane pisne playlistu
        if (!(0, _docs.isSongsLoaded)(state, routeParams.itemId)) {
          if (!routeParams.itemId.startsWith('p:')) {
            //playlist
            var promise = dispatch((0, _docs.loadSongs)(routeParams.itemId));
            promises.push(promise);
          } else {
            var _plId = routeParams.itemId.substring(2);
            promises.push(dispatch((0, _docs.loadPlaylistData)(_plId)));
          }
        }
      }

      if (routeParams.subItemId && !(0, _docs.isDocumentLoaded)(state, routeParams.subItemId, routeParams.versionId)) {
        promises.push(dispatch((0, _docs.loadDocument)(routeParams.subItemId, routeParams.versionId)));
      }
    }
  }
  // handling of this urls: http://localhost:3000/?_escaped_fragment_=D8MGiscuteWGeFrhm/asas
  var oldFormatId = location.query._escaped_fragment_;
  if (oldFormatId) {
    var oldFormatIdOnly = oldFormatId.split('/')[0];
    console.log('>>>>>>>>>>>>>>>>>>>' + oldFormatIdOnly);
    var _promise = dispatch((0, _docs.loadSiblingSongs)(oldFormatIdOnly)).then(function (res) {
      // console.log(res);
      // res.result.personId
      // toto je workaround, protože nevím jak si to předat do metody render jinak
      location.agamaData = res.result;
      return res;
    });
    promises.push(_promise);
  }

  return _promise3.default.all(promises);
}

var Docs = _wrapComponent('Docs')((_dec = (0, _connectData2.default)(fetchData), _dec2 = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data, authState: state.auth };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ /*loadSongs,*/panelVisibleToSide: _info.panelVisibleToSide, switchOuterToInner: _info.switchOuterToInner }, dispatch);
}), _dec(_class3 = _dec2(_class3 = (_temp3 = _class4 = function (_Component3) {
  (0, _inherits3.default)(Docs, _Component3);

  function Docs() {
    (0, _classCallCheck3.default)(this, Docs);
    return (0, _possibleConstructorReturn3.default)(this, (Docs.__proto__ || (0, _getPrototypeOf2.default)(Docs)).apply(this, arguments));
  }

  (0, _createClass3.default)(Docs, [{
    key: 'handleOldAdress',

    // static contextTypes = {
    //   router: React.PropTypes.func
    // }

    value: function handleOldAdress() {
      //#region MyRegion
      var redirector = null;
      var oldFormatId = this.props.location.query._escaped_fragment_;
      var legacyPush = this.props.docs.legacyPush;
      var documentCache = this.props.docs.documentCache;
      if (oldFormatId) oldFormatId = oldFormatId.split('/')[0]; // adresa muze byt ve tvaru "?_escaped_fragment_=mongoxid/COKOLIV" --> zde odstraníme COKOLIV
      if (oldFormatId && legacyPush && oldFormatId === legacyPush.legacyXid) {
        // při adrese http://localhost:3000/?_escaped_fragment_=AseCnhNPjhFe6stY8/cokoliv  kde AseCnhNPjhFe6stY8 je mongoXid osoby
        // legacyPush example: {"legacyXid":"AseCnhNPjhFe6stY8","personXid":"asecnhnpjhfe6sty8xadghkmpq","title":"Bokomara"}

        // při adrese http://localhost/?_escaped_fragment_=zpqKFuoaxHvpsdkcS  kde zpqKFuoaxHvpsdkcS je mongoXid písně
        // legacyPush example:  {legacyXid: "zpqKFuoaxHvpsdkcS", personXid: "asecnhnpjhfe6sty8xadghkmpq", title: "Ošklivky", songXid: XID}

        var itemId = legacyPush.personXid;
        var title = legacyPush.title;
        var subItemId = null;
        if (legacyPush.songXid) {
          // pokud šlo o mongo-xid písně - objekt písně byl již v 'docs.js' vložen do documentCache
          subItemId = legacyPush.songXid;
        }
        var newUrl = '/' + itemId + '/' + title;
        if (subItemId) newUrl = newUrl + '/' + subItemId + '/' + documentCache[subItemId].name;
        redirector = _react3.default.createElement(Redirector, { url: newUrl });
      }
      return redirector;
      //#endregion 
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      // agama still handles old url-format http://localhost:3000/?_escaped_fragment_=D8MGiscuteWGeFrhm
      var _props = this.props,
          panelVisibleToSide = _props.panelVisibleToSide,
          switchOuterToInner = _props.switchOuterToInner,
          params = _props.params,
          docs = _props.docs,
          info = _props.info,
          authState = _props.authState; // eslint-disable-line no-shadow

      var itemId = params.itemId,
          subItemId = params.subItemId,
          title = params.title,
          subTitle = params.subTitle,
          versionId = params.versionId; // itemId i title prijdou z URL

      var user = authState.user; //eslint-disable-line

      var chordBase = this.props.params.chordBase;
      var data = docs.data,
          songsByPersonCache = docs.songsByPersonCache,
          documentCache = docs.documentCache,
          playLists = docs.playLists,
          publicPlaylists = docs.publicPlaylists;

      var showInnerPanelContent /*bool*/ = !(info.ui.subNavigationDisplay.startsWith('pushed ') || info.ui.subNavigationZ === 'sub');
      var styles = require('./Docs.scss');
      var wrapForBorder = function wrapForBorder(elem) {
        return _react3.default.createElement(
          'div',
          { className: styles.mainPanelBody },
          elem
        );
      };

      if (!title) title = '';
      if (subTitle && subTitle.length > 0) title += ' ' + subTitle + ' - Akordy a text písně na kytaru';else title += (title.length === 0 ? '' : ' - ') + 'Texty písní s akordy na kytaru - zpěvník';

      //kontrola ze je vse ready
      if (data.docs.persons.length === 0) return _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement('br', null),
        'The Web server is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server. ',
        _react3.default.createElement('br', null),
        'Please try later..'
      );

      var getAll = function getAll(outerPanel, innerPanel, body) {
        var maintenanceMsg = data.maintenance ? _react3.default.createElement(
          'div',
          { className: styles.maintenanceMsg },
          data.maintenance
        ) : null;
        return _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
              'div',
              null,
              _react3.default.createElement(_reactHelmet2.default, { title: title }),
              _react3.default.createElement(
                _components2.MainPanel,
                { onePanel: innerPanel == null },
                maintenanceMsg,
                body
              ),
              outerPanel,
              innerPanel,
              _this4.handleOldAdress(),
              _react3.default.createElement(_components2.FindResult, null),
              _react3.default.createElement(Initializer, null)
            )
          )
        );
      };
      var publicPlaylistsTitle = 'Veřejné playlisty';
      var getOuterPanel = function getOuterPanel(onePanel /*zda jde o samostaný panel - druhy neni videt*/) {

        var pls = playLists || [];
        var separator = [{ isSeparator: true, name: '' }];
        var convertPlayListObj = function convertPlayListObj(playListInfo) {
          return { id: 'p:' + playListInfo.id, name: playListInfo.name.length > 0 ? playListInfo.name : '? playlist', uiType: 'playlist' };
        };
        var enhancePerson = function enhancePerson(person) {
          return (0, _extends3.default)({}, person, { scheme: 'MusicGroup' });
        };
        var persons = data.docs.persons.filter(function (x) {
          return x.used;
        });
        var playlistsIdsVisibleForCurrentUser = user ? user.data.playLists.map(function (pl) {
          return pl.id;
        }) : [];
        var visibleForCurrentUser = function visibleForCurrentUser(pl) {
          return playlistsIdsVisibleForCurrentUser.indexOf(pl.id) > -1;
        };

        var allPublicPlaylistsLink = [{ id: 'playlists', name: publicPlaylistsTitle, uiType: 'playlist' }];
        var onItemClick = function onItemClick() {
          switchOuterToInner({ name: 'navigation', childPanelName: 'subNavigation', mySide: 'left' });
        };
        var outerItems = pls.filter(visibleForCurrentUser).map(convertPlayListObj).concat(allPublicPlaylistsLink).concat(separator).concat(persons.map(enhancePerson));
        var outerPanelHeader = _react3.default.createElement(
          'h1',
          { itemprop: 'name' },
          'Playlisty / Interpreti: '
        );
        return _react3.default.createElement(
          _components2.SidePanel,
          { name: 'navigation', childPanelName: 'subNavigation', onePanel: onePanel, itemScope: true, itemType: 'http://schema.org/SiteNavigationElement' },
          _react3.default.createElement(
            _components2.HeadFootPanel,
            { header: outerPanelHeader, className: styles.outerHeading },
            _react3.default.createElement(_components2.DocList, { currentId: itemId, items: outerItems, onItemClick: onItemClick })
          )
        );
      };

      if (itemId == null) return getAll(getOuterPanel(true), null, _react3.default.createElement(_components2.InfoPage, null));

      if (itemId === 'playlists') {
        /* Verejne playlisty */
        var convertPlayListObj = function convertPlayListObj(playListInfo) {
          return (0, _extends3.default)({}, playListInfo, { id: 'p:' + playListInfo.id, name: playListInfo.name.length > 0 ? playListInfo.name : '? playlist', uiType: 'playlist' });
          //return {id: 'p:' + playListInfo.id, name: playListInfo.name.length > 0 ? playListInfo.name : '? playlist', uiType: 'playlist' };
        };
        var items = publicPlaylists.map(convertPlayListObj);
        //const header = <h1>Veřejné playlisty </h1>;
        var targetRoute = '/' + itemId + '/' + (0, _utils.frindlyName)(publicPlaylistsTitle);
        var header = _react3.default.createElement(
          'h1',
          { itemprop: 'name' },
          _react3.default.createElement(
            _reactRouter.Link,
            { to: targetRoute },
            publicPlaylistsTitle
          ),
          ': \xA0\xA0\xA0',
          _react3.default.createElement(
            'small',
            null,
            '[ ',
            items && items.length,
            ' ]'
          )
        );

        var parentItem = { id: 'playlists', name: publicPlaylistsTitle };
        var onSubItemClick = function onSubItemClick() {};
        var body = void 0;
        if (subItemId) {
          var plId = subItemId.substring(2);
          var pl = (docs.playLists || []).find(function (_pl) {
            return _pl.id === plId;
          }); //todo: first
          //innerHeaderTitle = pl ? pl.name : null;
          body = wrapForBorder(_react3.default.createElement(_components2.PlaylistEditor, { playListId: plId }));
        } else body = wrapForBorder(_react3.default.createElement(_components2.PublicPlaylistsList, { playlists: publicPlaylists, targetRouteFunc: function targetRouteFunc(pl) {
            return '/playlists/' + (0, _utils.frindlyName)(publicPlaylistsTitle) + '/p:' + pl.id + '/' + (0, _utils.frindlyName)(pl.name);
          } }));

        var innerPanel = _react3.default.createElement(
          _components2.SidePanel,
          { name: 'subNavigation', parentPanelName: 'navigation' },
          _react3.default.createElement(
            _components2.HeadFootPanel,
            { header: header, footer: null, className: showInnerPanelContent ? '' : styles.invisible },
            _react3.default.createElement(_components2.DocList, { currentId: subItemId, items: items, parentItem: parentItem, parentPropName: 'persons', onItemClick: onSubItemClick })
          )
        );

        return getAll(getOuterPanel(), innerPanel, body);
      }

      if (itemId != null) {
        var outerType = 'Person';
        if (itemId.startsWith('p:')) outerType = 'Playlist';
        var innerType = subItemId ? (documentCache[subItemId] || {}).type : null;
        //const invalidSubItem = subItemId && innerType==null;
        var _items = songsByPersonCache[itemId];

        var _body = null;
        var innerHeaderTitle = null;
        if (outerType === 'Person') {
          /*PERSON*/
          var personPole = data.docs.persons.filter(function (person) {
            return person.id === itemId;
          }); // todo: stacilo filterFirst
          if (personPole.length > 0) {
            // vzdy bude jedne nula nebo jeden prvek
            innerHeaderTitle = personPole[0].name; //
            _body = _react3.default.createElement(
              'div',
              { style: { color: 'gray', margin: '20px' } },
              ' zde se bude v budoucnu zobrazovat informace o interpretovi / skupin\u011B',
              _react3.default.createElement(
                'span',
                { itemScope: true, itemType: 'http://schema.org/MusicGroup' },
                '\xA0\'',
                _react3.default.createElement(
                  'span',
                  { itemProp: 'name' },
                  innerHeaderTitle
                ),
                '\''
              ),
              '\'',
              _react3.default.createElement('br', null),
              _react3.default.createElement('br', null),
              'Vlevo vyberte p\xEDse\u0148, kterou chcete zobrazit ',
              _react3.default.createElement('br', null),
              _react3.default.createElement('br', null),
              'nebo m\u016F\u017Eete ',
              _react3.default.createElement(
                _reactRouter.IndexLink,
                { to: '/', activeStyle: { color: '#33e0ff' } },
                'p\u0159ej\xEDt na \xFAvodn\xED str\xE1nku ...'
              )
            );
          }
        } else if (outerType === 'Playlist') {
          /*PLAYLISTY */
          var _plId2 = itemId.substring(2);
          var _pl2 = (docs.playLists || []).find(function (_pl) {
            return _pl.id === _plId2;
          }); //todo: first
          if (_pl2) {
            innerHeaderTitle = _pl2.name;
            _body = wrapForBorder(_react3.default.createElement(_components2.PlaylistEditor, { playListId: _plId2 }));
          }
        }

        var tools = void 0;
        var toolsMini = void 0;
        var _parentItem = { id: itemId, name: innerHeaderTitle || 'show' };

        var _targetRoute = '/' + itemId + '/' + (0, _utils.frindlyName)(innerHeaderTitle || 'show');
        var _header = innerHeaderTitle !== null // prazdnyretezec muze take nastat // eslint-disable-line
        ? _react3.default.createElement(
          'h1',
          { itemprop: 'name' },
          _react3.default.createElement(
            _reactRouter.Link,
            { to: _targetRoute },
            ' ',
            innerHeaderTitle,
            ' '
          ),
          ': \xA0\xA0\xA0',
          _react3.default.createElement(
            'small',
            null,
            '[ ',
            _items && _items.length,
            ' ]'
          )
        ) : ' Not found or access denied';

        if (innerType === 'Song') {
          var doc = documentCache[subItemId];
          var docName = doc.name;
          tools = _react3.default.createElement(_components2.SongTools, { currentChord: chordBase, xid: subItemId, path: '/' + itemId + '/' + innerHeaderTitle + '/' + subItemId + '/' + docName + '/' });
          toolsMini = _react3.default.createElement(_components2.SongTools, { mini: true, currentChord: chordBase, xid: subItemId, path: '/' + itemId + '/' + innerHeaderTitle + '/' + subItemId + '/' + docName + '/' });
          //showMiniTools /*bool*/ = info.ui.subNavigationDisplay.startsWith('pushed ') || info.ui.subNavigationZ === 'sub';
          _body = _react3.default.createElement(_components2.Song, { xid: subItemId, versionId: versionId, currentChord: chordBase, path: '/' + itemId + '/' + innerHeaderTitle + '/' + subItemId + '/' + docName });
        }
        var _onSubItemClick = function _onSubItemClick() {
          var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
          if (width > height) return;
          if (_parentItem) {
            panelVisibleToSide({ name: 'navigation', childPanelName: 'subNavigation', mySide: 'left' });
          }
        };
        if (!_body) {
          return getAll(getOuterPanel(), null, wrapForBorder(_react3.default.createElement(
            'h1',
            null,
            '404 - Not found / Nenalezeno'
          )));
        }

        //rozsirime data o mikrodata
        var enhancedItems = _items != null ? _items.map(function (song) {
          return (0, _extends3.default)({}, song, { scheme: 'MusicComposition' });
        }) : null;

        var _innerPanel = _react3.default.createElement(
          _components2.SidePanel,
          { name: 'subNavigation', parentPanelName: 'navigation' },
          _react3.default.createElement(
            _components2.HeadFootPanel,
            { header: _header, footer: tools, className: showInnerPanelContent ? '' : styles.invisible },
            _react3.default.createElement(_components2.DocList, { currentId: subItemId, items: enhancedItems, parentItem: _parentItem, parentPropName: 'persons', onItemClick: _onSubItemClick })
          ),
          _react3.default.createElement(
            'div',
            { className: showInnerPanelContent ? styles.invisible : styles.miniToolContainer },
            toolsMini
          )
        );
        return getAll(getOuterPanel(), _innerPanel, _body);
      }

      return wrapForBorder(_react3.default.createElement(
        'h1',
        null,
        'Error'
      ));
    }
  }]);
  return Docs;
}(_react2.Component), _class4.propTypes = {
  params: _react2.PropTypes.object,
  docs: _react2.PropTypes.object,
  info: _react2.PropTypes.object,
  authState: _react2.PropTypes.object,
  //loadSongs: PropTypes.func,
  location: _react2.PropTypes.object,
  panelVisibleToSide: _react2.PropTypes.func,
  switchOuterToInner: _react2.PropTypes.func,
  subPage: _react2.PropTypes.string
}, _temp3)) || _class3) || _class3));

exports.default = Docs;

// if (outerType == 'Playlist') {
//     const plId = itemId.substring(2);
//     const pl = (docs.playLists || []).find(_pl=>_pl.id === plId); //todo: first
//     const playListName = pl ? pl.name : null;
//     const parentItem = {id: itemId, name: title};
//     const tools = <div>OK</div>;

//     const innerPanel = (<SidePanel name="subNavigation" parentPanelName="navigation" >
//         <HeadFootPanel header={header} footer={tools} className={showMiniTools ? styles.invisible : ''}>
//           <DocList currentId={subItemId} items={items} parentItem={parentItem} parentPropName="persons" onItemClick={onSubItemClick} />
//         </HeadFootPanel>
//         <div className={showMiniTools ? styles.miniToolContainer : styles.invisible}>{toolsMini}</div>
//     </SidePanel>);
//     if (!innerType) {

//       const body = <PlaylistEditor playListId={plId} />;
//       return getAll(getOuterPanel(), innerPanel, body)
//     }
// }

//  case 'Song':
//   docName = documentCache[subItemId].name;
//   viewComponent = <Song xid={subItemId} versionId={versionId} currentChord={chordBase} path={'/' + itemId + '/' + personName + '/' + subItemId + '/' + docName  } />;
//   tools = <SongTools currentChord={chordBase} xid={subItemId} path={'/' + itemId + '/' + personName + '/' + subItemId + '/' + docName + '/'}/>;
//   toolsMini = <SongTools mini currentChord={chordBase} xid={subItemId} path={'/' + itemId + '/' + personName + '/' + subItemId + '/' + docName + '/'}/>;
//   break;

// case 'Playlist' :
//   const plId = itemId.substring(2);
//   viewComponent = <PlaylistEditor playListId={plId} />;
//   const pl = (docs.playLists || []).find(_pl=>_pl.id === plId);
//   playListName = pl ? pl.name : null;
//   // viewComponent = <div>PL {JSON.stringify(playList, null, 4)}</div>;
//   break;


//  const header = innerHeaderTitle !== null  // prazdnyretezec muze take nastat // eslint-disable-line
//   ? <h1><Link to={targetRoute}> {innerHeaderTitle} </Link>: &nbsp;&nbsp;&nbsp;<small>[ {items && items.length} ]</small></h1>
//   : ' Not found or access denied';
//   const onSubItemClick = ()=>{
//     const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
//     const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
//     if (width > height) return;
//     if (parentItem) {
//       panelVisibleToSide({name: 'navigation', childPanelName: 'subNavigation', mySide: 'left'});
//     }
//   };


//  const innerPanel =
//     (<SidePanel name="subNavigation" parentPanelName="navigation" >
//         <HeadFootPanel header={header} footer={tools} className={showMiniTools ? styles.invisible : ''}>
//            <DocList currentId={subItemId} items={items} parentItem={parentItem} parentPropName="persons" onItemClick={onSubItemClick} />
//         </HeadFootPanel>
//         <div className={showMiniTools ? styles.miniToolContainer : styles.invisible}>{toolsMini}</div>
//     </SidePanel>);


//return getAll(getOuterPanel(), null, <div>404 not found</div>);


// const parentItem = {id: itemId, name: title};

// let innerPanel = null;
// const getTypeById = (_id)=>{
//   if (!_id) return 'HomePage';
//   if (_id=='playlists') return 'PublicPlaylists';
//   if (_id.startsWith('p:')) return 'Playlist';
//   return 'Person';
// };
// const styles = require('./Docs.scss');
// const outerType = getTypeById(itemId);  // eslint-disable-line 

// if (outerType === 'PublicPlaylists')
//  itemId = null;

// const innerType = subItemId ? (documentCache[subItemId] || {}).type : null;
// const items = itemId ? songsByPersonCache[itemId] : null;
// let viewComponent;
// let tools;
// let toolsMini;
// let docName;
// const showMiniTools = info.ui.subNavigationDisplay.startsWith('pushed ') || info.ui.subNavigationZ === 'sub';
// let personName = null;
// if (itemId && outerType === 'Person') {
//   const personPole = data.docs.persons.filter(person => person.id === itemId); // todo: stacilo filterFirst
//   if (personPole.length > 0) { // vzdy bude jedne nula nebo jeden prvek
//     personName = personPole[0].name;
//   }
// }
// let playListName = null;
// const setComponents = (caseName) => {
//   switch (caseName) {
//     case 'PublicPlaylists' :
//       viewComponent = <PublicPlaylistsList playlists={publicPlaylists} />
//       ;break;
//     case 'Person' :
//       viewComponent = (
//         <div style={{color: 'gray', margin: '20px' }}> zde se bude v budoucnu zobrazovat informace o interpretovi / skupině '{personName}'<br /><br />
//             Vlevo vyberte píseň, kterou chcete zobrazit <br /><br />
//             nebo můžete <IndexLink to="/" activeStyle={{color: '#33e0ff'}}>přejít na úvodní stránku ...</IndexLink>
//         </div>
//         );
//       break;
//     case 'Playlist:Song':
//       setComponents('Playlist');
//       setComponents('Song');
//       break;
//     case 'Person:Song':
//       setComponents('Song');
//       break;
//     case 'Song':
//       docName = documentCache[subItemId].name;
//       viewComponent = <Song xid={subItemId} versionId={versionId} currentChord={chordBase} path={'/' + itemId + '/' + personName + '/' + subItemId + '/' + docName  } />;
//       tools = <SongTools currentChord={chordBase} xid={subItemId} path={'/' + itemId + '/' + personName + '/' + subItemId + '/' + docName + '/'}/>;
//       toolsMini = <SongTools mini currentChord={chordBase} xid={subItemId} path={'/' + itemId + '/' + personName + '/' + subItemId + '/' + docName + '/'}/>;
//       break;
//     case 'HomePage' :
//       viewComponent = <InfoPage />;
//       break;
//     case 'Playlist' :
//       const plId = itemId.substring(2);
//       viewComponent = <PlaylistEditor playListId={plId} />;
//       const pl = (docs.playLists || []).find(_pl=>_pl.id === plId);
//       playListName = pl ? pl.name : null;
//       // viewComponent = <div>PL {JSON.stringify(playList, null, 4)}</div>;
//       break;
//     default:
//       viewComponent = <div> </div>;
//   }
// };
// const caseName = outerType + (innerType ? (':' + innerType) : '');
// setComponents(caseName);

// const docTitle = (personName && docName) // eslint-disable-line no-nested-ternary
//      ? docName + ', ' + personName
//      : (
//          personName
//            ? personName
//            : 'Zpěvník s akordy'
//         );


// if (itemId) {
//   const frindlyName = name => name !=null ? name.replace(/\?/g, '') : null; //eslint-disable-line
//   const innerHeaderTitle = personName || playListName;
//   const targetRoute = ('/' + itemId + '/' + frindlyName(innerHeaderTitle));
//   const header = innerHeaderTitle !== null  // prazdnyretezec muze take nastat // eslint-disable-line
//   ? <h1><Link to={targetRoute}> {innerHeaderTitle} </Link>: &nbsp;&nbsp;&nbsp;<small>[ {items && items.length} ]</small></h1>
//   : ' Not found or access denied';
//   const onSubItemClick = ()=>{
//     const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
//     const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
//     if (width > height) return;
//     if (parentItem) {
//       panelVisibleToSide({name: 'navigation', childPanelName: 'subNavigation', mySide: 'left'});
//     }
//   };
//   innerPanel =
//       (<SidePanel name="subNavigation" parentPanelName="navigation" >
//           <HeadFootPanel header={header} footer={tools} className={showMiniTools ? styles.invisible : ''}>
//              <DocList currentId={subItemId} items={items} parentItem={parentItem} parentPropName="persons" onItemClick={onSubItemClick} />
//           </HeadFootPanel>
//           <div className={showMiniTools ? styles.miniToolContainer : styles.invisible}>{toolsMini}</div>
//       </SidePanel>);
// } else {
//   innerPanel =
//     (<SidePanel name="subNavigation" parentPanelName="navigation" ref="subNavigation">
//       <br /><br /><br />&nbsp;&nbsp;
//       <Glyphicon glyph="info-sign" style={{color: 'silver', fontSize: '30px'}}/><br />
//       <div>&nbsp;&nbsp;&lt; Vyberte interpreta</div>
//     </SidePanel>);
// }
// const onItemClick = ()=>{
//   switchOuterToInner({name: 'navigation', childPanelName: 'subNavigation', mySide: 'left'});
// };

// const convertPlayListObj = playListInfo => {
//   return {id: 'p:' + playListInfo.id, name: playListInfo.name.length > 0 ? playListInfo.name : '? playlist', uiType: 'playlist' };
// };
// const maintenanceMsg = (data.maintenance) ? <div className={styles.maintenanceMsg}>{data.maintenance}</div> : null;
// const hasPlaylists = (playLists && playLists.length > 0);
// const separator = hasPlaylists ? [{isSeparator: true, name: '' }] : [];
// const outerItems = playLists.map(convertPlayListObj).concat(separator).concat(data.docs.persons.filter(x=>x.used));
// //const addPerson =  (<span><ToolButton glyphIconName="plus" inGroup linkTo="/create/person"  /></span>);

// const outerPanelHeader = hasPlaylists ? <h1>Playlisty / Interpreti: </h1> : <h1>Interpreti: </h1>;
// const outerPanel =
//    (<SidePanel name="navigation" childPanelName="subNavigation" >
//           <HeadFootPanel header={outerPanelHeader} className={styles.outerHeading}>
//             <DocList currentId={itemId} items={outerItems} onItemClick={onItemClick} />
//           </HeadFootPanel>
//      </SidePanel>);
// return (
//   <div>
//     <div>
//       <div>
//         <Helmet title={docTitle}/>
//         <MainPanel>
//          {maintenanceMsg}
//          {viewComponent}
//         </MainPanel>
//         {outerPanel}
//         {innerPanel}
//         {this.handleOldAdress()}
//         <FindResult/>
//         <Initializer />
//       </div>
//     </div>
//   </div>
// );


//////////////////
// WEBPACK FOOTER
// ./src/containers/Docs/Docs.js
// module id = 1207
// module chunks = 0